export default {
    "__schema": {
        "types": [{
            "kind": "INTERFACE",
            "name": "CartAddressInterface",
            "possibleTypes": [{"name": "BillingCartAddress"}, {"name": "ShippingCartAddress"}]
        }, {
            "kind": "INTERFACE",
            "name": "CartItemInterface",
            "possibleTypes": [{"name": "SimpleCartItem"}, {"name": "VirtualCartItem"}, {"name": "DownloadableCartItem"}, {"name": "ConfigurableCartItem"}, {"name": "BundleCartItem"}, {"name": "GiftCardCartItem"}]
        }, {
            "kind": "INTERFACE",
            "name": "ProductInterface",
            "possibleTypes": [{"name": "VirtualProduct"}, {"name": "SimpleProduct"}, {"name": "DownloadableProduct"}, {"name": "BundleProduct"}, {"name": "GroupedProduct"}, {"name": "ConfigurableProduct"}, {"name": "GiftCardProduct"}]
        }, {
            "kind": "INTERFACE",
            "name": "CategoryInterface",
            "possibleTypes": [{"name": "CategoryTree"}]
        }, {
            "kind": "INTERFACE",
            "name": "CategoryProductInterface",
            "possibleTypes": [{"name": "CategoryProduct"}]
        }, {
            "kind": "INTERFACE",
            "name": "GuaranteeInterface",
            "possibleTypes": [{"name": "Guarantee"}]
        }, {
            "kind": "INTERFACE",
            "name": "ProductPriceInterface",
            "possibleTypes": [{"name": "ProductPrice"}]
        }, {
            "kind": "INTERFACE",
            "name": "MediaGalleryInterface",
            "possibleTypes": [{"name": "ProductImage"}, {"name": "ProductVideo"}]
        }, {
            "kind": "INTERFACE",
            "name": "ProductLinksInterface",
            "possibleTypes": [{"name": "ProductLinks"}]
        }, {
            "kind": "INTERFACE",
            "name": "RoutableInterface",
            "possibleTypes": [{"name": "CategoryTree"}, {"name": "CmsPage"}, {"name": "VirtualProduct"}, {"name": "SimpleProduct"}, {"name": "DownloadableProduct"}, {"name": "BundleProduct"}, {"name": "GroupedProduct"}, {"name": "ConfigurableProduct"}, {"name": "GiftCardProduct"}]
        }, {
            "kind": "INTERFACE",
            "name": "CurrentStorePathsInterface",
            "possibleTypes": [{"name": "CurrentStorePath"}]
        }, {
            "kind": "INTERFACE",
            "name": "GiftRegistryDynamicAttributeInterface",
            "possibleTypes": [{"name": "GiftRegistryDynamicAttribute"}, {"name": "GiftRegistryRegistrantDynamicAttribute"}]
        }, {
            "kind": "INTERFACE",
            "name": "GiftRegistryItemInterface",
            "possibleTypes": [{"name": "GiftRegistryItem"}]
        }, {
            "kind": "INTERFACE",
            "name": "GiftRegistryDynamicAttributeMetadataInterface",
            "possibleTypes": [{"name": "GiftRegistryDynamicAttributeMetadata"}]
        }, {
            "kind": "INTERFACE",
            "name": "CreditMemoItemInterface",
            "possibleTypes": [{"name": "DownloadableCreditMemoItem"}, {"name": "BundleCreditMemoItem"}, {"name": "CreditMemoItem"}, {"name": "GiftCardCreditMemoItem"}]
        }, {
            "kind": "INTERFACE",
            "name": "OrderItemInterface",
            "possibleTypes": [{"name": "DownloadableOrderItem"}, {"name": "BundleOrderItem"}, {"name": "OrderItem"}, {"name": "GiftCardOrderItem"}]
        }, {
            "kind": "INTERFACE",
            "name": "InvoiceItemInterface",
            "possibleTypes": [{"name": "DownloadableInvoiceItem"}, {"name": "BundleInvoiceItem"}, {"name": "InvoiceItem"}, {"name": "GiftCardInvoiceItem"}]
        }, {
            "kind": "INTERFACE",
            "name": "ShipmentItemInterface",
            "possibleTypes": [{"name": "BundleShipmentItem"}, {"name": "ShipmentItem"}, {"name": "GiftCardShipmentItem"}]
        }, {
            "kind": "INTERFACE",
            "name": "WishlistItemInterface",
            "possibleTypes": [{"name": "SimpleWishlistItem"}, {"name": "VirtualWishlistItem"}, {"name": "DownloadableWishlistItem"}, {"name": "BundleWishlistItem"}, {"name": "GroupedProductWishlistItem"}, {"name": "ConfigurableWishlistItem"}, {"name": "GiftCardWishlistItem"}]
        }, {
            "kind": "INTERFACE",
            "name": "AggregationOptionInterface",
            "possibleTypes": [{"name": "AggregationOption"}]
        }, {
            "kind": "INTERFACE",
            "name": "LayerFilterItemInterface",
            "possibleTypes": [{"name": "LayerFilterItem"}, {"name": "SwatchLayerFilterItem"}]
        }, {
            "kind": "INTERFACE",
            "name": "GiftRegistryOutputInterface",
            "possibleTypes": [{"name": "MoveCartItemsToGiftRegistryOutput"}, {"name": "GiftRegistryOutput"}]
        }, {
            "kind": "INTERFACE",
            "name": "GiftRegistryItemUserErrorInterface",
            "possibleTypes": [{"name": "MoveCartItemsToGiftRegistryOutput"}, {"name": "GiftRegistryItemUserErrors"}]
        }, {
            "kind": "INTERFACE",
            "name": "PhysicalProductInterface",
            "possibleTypes": [{"name": "SimpleProduct"}, {"name": "BundleProduct"}, {"name": "GroupedProduct"}, {"name": "ConfigurableProduct"}, {"name": "GiftCardProduct"}]
        }, {
            "kind": "INTERFACE",
            "name": "CustomizableOptionInterface",
            "possibleTypes": [{"name": "CustomizableAreaOption"}, {"name": "CustomizableDateOption"}, {"name": "CustomizableDropDownOption"}, {"name": "CustomizableMultipleOption"}, {"name": "CustomizableFieldOption"}, {"name": "CustomizableFileOption"}, {"name": "CustomizableRadioOption"}, {"name": "CustomizableCheckboxOption"}]
        }, {
            "kind": "INTERFACE",
            "name": "CustomizableProductInterface",
            "possibleTypes": [{"name": "VirtualProduct"}, {"name": "SimpleProduct"}, {"name": "DownloadableProduct"}, {"name": "BundleProduct"}, {"name": "ConfigurableProduct"}, {"name": "GiftCardProduct"}]
        }, {
            "kind": "INTERFACE",
            "name": "SwatchDataInterface",
            "possibleTypes": [{"name": "ImageSwatchData"}, {"name": "TextSwatchData"}, {"name": "ColorSwatchData"}]
        }, {
            "kind": "INTERFACE",
            "name": "SwatchLayerFilterItemInterface",
            "possibleTypes": [{"name": "SwatchLayerFilterItem"}]
        }, {
            "kind": "INTERFACE",
            "name": "ProductAttachmentsInterface",
            "possibleTypes": [{"name": "ProductAttachment"}]
        }]
    }
}
